import React from 'react';
import { IntlShape } from 'react-intl';
import moment from 'moment';
import Tag from 'antd/lib/tag';
import { FleetReportData } from '../../@types';
import {
  alphabeticalSorterFor,
  chronologicalSorterFor,
} from '../shared/TableLayout';
import { renderText, renderNumber } from '../shared/DrawerLayout/renderText';
import { colors } from '../../theme/theme';

type GetColumnsArgs = {
  intl: IntlShape;
};

const getColumns = ({ intl }: GetColumnsArgs) => {
  const renderStatus = (status: FleetReportData['status']) => {
    return (
      <span>
        {intl.formatMessage({
          id: `fleetadmin.reports.table.${status}`,
        })}
      </span>
    );
  };

  const renderUploadUrl = (url: string) => {
    if (!url) return <span>-</span>;
    return (
      <span
        style={{ color: colors.blue, cursor: 'pointer' }}
        onClick={() => window.open(url, '_blank')}
      >
        open
      </span>
    );
  };

  const renderDateTime = (value: string) => {
    if (!value) return <span>-</span>;
    const m = moment(value);
    return <span>{m.isValid() ? m.format('DD MMM. YYYY') : '-'}</span>;
  };
  return [
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.reportclass' }),
      dataIndex: 'reportClass',
      ellipsis: true,
      width: 180,
      render: renderText,
      sorter: alphabeticalSorterFor('reportClass'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.from' }),
      dataIndex: 'from',
      ellipsis: true,
      width: 160,
      render: renderDateTime,
      sorter: chronologicalSorterFor('from'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.to' }),
      dataIndex: 'to',
      ellipsis: true,
      width: 160,
      render: renderDateTime,
      sorter: chronologicalSorterFor('to'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.filename' }),
      dataIndex: 'fileName',
      ellipsis: true,
      width: 300,
      render: renderText,
      sorter: alphabeticalSorterFor('fileName'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.status' }),
      dataIndex: 'status',
      ellipsis: true,
      width: 160,
      render: renderStatus,
      sorter: alphabeticalSorterFor('status'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.created' }),
      dataIndex: 'created',
      ellipsis: true,
      width: 180,
      render: renderDateTime,
      sorter: chronologicalSorterFor('created'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.reports.table.pendingsince',
      }),
      dataIndex: 'pendingSince',
      ellipsis: true,
      width: 180,
      render: renderDateTime,
      sorter: chronologicalSorterFor('pendingSince'),
    },
    {
      title: intl.formatMessage({
        id: 'fleetadmin.reports.table.processingat',
      }),
      dataIndex: 'processingAt',
      ellipsis: true,
      width: 180,
      render: renderDateTime,
      sorter: chronologicalSorterFor('processingAt'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.generatedat' }),
      dataIndex: 'generatedAt',
      ellipsis: true,
      width: 180,
      render: renderDateTime,
      sorter: chronologicalSorterFor('generatedAt'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.uploadedat' }),
      dataIndex: 'uploadedAt',
      ellipsis: true,
      width: 180,
      render: renderDateTime,
      sorter: chronologicalSorterFor('uploadedAt'),
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.uploadurl' }),
      dataIndex: 'url',
      ellipsis: true,
      width: 300,
      render: renderUploadUrl,
    },
    {
      title: intl.formatMessage({ id: 'fleetadmin.reports.table.statuscode' }),
      dataIndex: 'statusCode',
      ellipsis: true,
      width: 160,
      render: (code: number) =>
        code != null ? renderNumber(code) : <span>-</span>,
    },
  ];
};

export default getColumns;
